/** Router `location.state` for “jump to All Restaurants” — use instead of `/#all-restaurants` (hash makes refresh skip the banner). */
export const SCROLL_ALL_RESTAURANTS = { scrollToAllRestaurants: true };
